import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { taskKeys, RequestTypes } from '@core/react-query/features/tasks/task'
import { AuditResult, IAuditResult } from '@core/entities/audit/AuditResult'
import { PageResponse } from '@core/entities/pagination/PageResponse'
import { usePageableQuery } from '@core/react-query/hooks'

const dataTransformer = ({ content }: PageResponse<IAuditResult>) => {
  return content.map((audit) => AuditResult.new(audit))
}

export const useGetTaskTimeline = (
  payload: RequestTypes['getTaskTimeline'],
  options?: UseInfiniteQueryOptions<
    PageResponse<IAuditResult>,
    string,
    Array<AuditResult>
  >,
) => {
  const taskTimelineQuery = taskKeys.timeline(payload)
  const infiniteQueryOptions = usePageableQuery({
    queryEnabled: options?.enabled,
    queryKey: taskTimelineQuery.queryKey,
    dataTransformer,
  })

  return useInfiniteQuery({
    ...infiniteQueryOptions,
    ...taskTimelineQuery,
    ...options,
  })
}
